<script>
import SvgIcon from "./SvgIcon.vue";
export default {
  components: { SvgIcon },
  name: "PopupForm",
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<template>
  <div class="popup-form-overlay" @click="close">
    <div class="popup-form" @click.stop>
      <div class="block-form-content">
        <button class="close" type="button" @click="close">
          <svg-icon icon="close"></svg-icon>
        </button>
        <div class="left">
          <div class="form-title">{{ $v("STR_CONTACT_US") }}</div>
          <div
            class="form-description"
            v-html="$v('STR_APPLICATION_FORM_DESCRIPTION')"
          ></div>
        </div>
        <request-form class="popup" @done="close"></request-form>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.popup-form-overlay {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.75);
  z-index: 100;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}

.popup-form {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
  width: 300px;

  padding: 50px 50px 40px 50px;
  background: #fff;

  box-shadow: 5px 10px 30px rgba(43, 158, 204, 0.25);
}

.form-title {
  font-weight: 600;
  font-size: 24px;
  text-align: center;
  margin-bottom: 3px;
}

.form-description {
  color: $color-text-grey;
  text-align: center;
  margin-bottom: 13px;
}

.close {
  position: absolute;
  right: 20px;
  top: 20px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: $color-dark;
  transition: color 0.3s;

  &:hover {
    color: $color-brand-1;
  }

  .icon {
    display: block;
  }
}
</style>
